import { ref } from "vue";

interface PaymentState {
  isVisible: boolean;
  amount: number;
  brCode: string;
  expiresIn: string;
  brCodeBase64: string;
  paymentId: string;
}

const paymentState = ref<PaymentState>({
  isVisible: false,
  amount: 0,
  brCode: "",
  expiresIn: "",
  brCodeBase64: "",
  paymentId: "",
});

export default paymentState;

export const usePayment = () => {
  const { isVisible, amount, brCode, brCodeBase64 } = paymentState.value;

  const openPaymentModal = (
    amount: number,
    brCode: string,
    brCodeBase64: string,
    expiresIn: string,
    paymentId: string,
  ) => {
    paymentState.value.isVisible = true;
    paymentState.value.amount = amount;
    paymentState.value.brCode = brCode;
    paymentState.value.brCodeBase64 = brCodeBase64;
    paymentState.value.expiresIn = expiresIn;
    paymentState.value.paymentId = paymentId;
  };

  const closePaymentModal = () => {
    paymentState.value.isVisible = false;
  };

  return {
    isVisible,
    amount,
    brCode,
    brCodeBase64,
    openPaymentModal,
    closePaymentModal,
  };
};
